<template>
  <CRow>
    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-file" />
          <h5 class="d-inline ml-2">MenutePay Invoices</h5>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "MenutePayInvoices",
  components: {
    BackendTable,
  },
};
</script>
